import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareWithIdDirective } from './compare-with-id.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [CompareWithIdDirective],
  exports: [CompareWithIdDirective],
})
export class CompareWithIdModule {}
